export function phoneDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export function isValidBrazilPhone(value: string): boolean {
  const digits = phoneDigits(value);
  return digits.length >= 10 && digits.length <= 13;
}

export function formatPairingCode(code: string): string {
  const clean = code.replace(/\W/g, '').toUpperCase();
  if (clean.length <= 4) return clean;
  return `${clean.slice(0, 4)}-${clean.slice(4, 8)}`;
}

export function formatPhoneDisplayFromDigits(digits: string): string {
  let d = digits.replace(/\D/g, '');
  if (d.length > 11 && d.startsWith('55')) {
    d = d.slice(d.length - 11);
  }
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7, 11)}`;
}

/** Formato alternativo BR (com/sem 9 do celular) para retentar pareamento. */
export function brazilMobileAlternateDigits(digits: string): string | null {
  let d = phoneDigits(digits);
  if (d.startsWith('55') && d.length >= 12) {
    d = d.slice(2);
  }
  if (d.length === 11 && d[2] === '9') {
    return d.slice(0, 2) + d.slice(3);
  }
  if (d.length === 10 && /^[6-9]/.test(d.slice(2))) {
    return `${d.slice(0, 2)}9${d.slice(2)}`;
  }
  return null;
}
